<div *mwcModalTitle class="mwc-text-xl-medium mwc-color-gray-900">Select Prompts</div>

<div class="prompts-modal-body">
  <!-- Dynamic alert banner -->
  <mwc-alert
    [mwcType]="alertType"
    [mwcMessage]="alertMsgTemplate"
    [mwcIcon]="alertIconTemplate"
    mwcShowIcon="true"
    class="prompts-alert">
  </mwc-alert>

  <ng-template #alertIconTemplate>
    <span mwc-icon
          [mwcIconfont]="selectedCount >= maxPromptsAllowed ? 'check-circle' : 'stars-02'"
          style="font-size: 16px;">
    </span>
  </ng-template>

  <ng-template #alertMsgTemplate>
    <span *ngIf="selectedCount >= maxPromptsAllowed" class="mwc-text-sm-medium">
      Perfect! You've selected all {{ maxPromptsAllowed }} prompts.
    </span>
    <span *ngIf="selectedCount === 0" class="mwc-text-sm-regular">
      Select <strong>{{ maxPromptsAllowed }} prompts</strong> for best results
    </span>
    <span *ngIf="selectedCount > 0 && selectedCount < maxPromptsAllowed" class="mwc-text-sm-regular">
      Select <strong>{{ remainingCount }} more prompt{{ remainingCount > 1 ? 's' : '' }}</strong> for best results
    </span>
  </ng-template>

  <!-- Prompts table -->
  <div class="prompts-table">
    <div class="prompts-table__header" role="row">
      <div class="prompts-table__header-cell prompts-table__header-cell--prompts" role="columnheader">
        <span class="mwc-text-xs-medium mwc-color-gray-600">Prompts</span>
        <span mwc-icon
              mwcIconfont="help-circle"
              mwc-tooltip
              mwcTooltipTitle="AI-recommended prompts based on your topic"
              class="prompts-table__help-icon"
              aria-hidden="true">
        </span>
      </div>
      <div class="prompts-table__header-cell prompts-table__header-cell--volume" role="columnheader">
        <span class="mwc-text-xs-medium mwc-color-gray-600">Estimated Query Volume</span>
        <span mwc-icon
              mwcIconfont="help-circle"
              mwc-tooltip
              mwcTooltipTitle="Approximate monthly search volume for this prompt"
              class="prompts-table__help-icon"
              aria-hidden="true">
        </span>
      </div>
    </div>
    <div class="prompts-table__body">
      <div *ngFor="let prompt of prompts"
           class="prompts-table__row"
           role="row"
           [class.prompts-table__row--selected]="prompt.selected"
           [class.prompts-table__row--disabled]="isDisabled(prompt)">
        <div class="prompts-table__cell prompts-table__cell--prompts" role="cell">
          <label mwc-checkbox
                 [mwcChecked]="prompt.selected"
                 [mwcDisabled]="isDisabled(prompt)"
                 (mwcCheckedChange)="togglePrompt(prompt, $event)">
            <span class="mwc-text-sm-medium mwc-color-gray-700 prompt-text">{{ prompt.text }}</span>
          </label>
        </div>
        <div class="prompts-table__cell prompts-table__cell--volume" role="cell">
          <span class="mwc-text-sm-regular mwc-color-gray-600">{{ prompt.estimatedQueryVolume != null ? (prompt.estimatedQueryVolume | number) : '—' }}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<div *mwcModalFooter>
  <button mwc-button mwcType="default" (click)="cancel()">Cancel</button>
  <button mwc-button mwcType="primary" [disabled]="selectedCount === 0" (click)="save()">Save</button>
</div>
